import React from 'react';

interface SkeletonLoaderProps {
  className?: string;
}

/**
 * ZAKTUALIZOWANY: Wyższy kontrast i lepsza adaptacja do zaokrągleń Solid Glass.
 */
const SkeletonLoader: React.FC<SkeletonLoaderProps> = ({ className }) => {
  return (
    <div
      className={`bg-white/10 animate-pulse ${className || 'rounded-xl'}`}
      data-testid="skeleton-loader"
      style={{
        // Dodajemy delikatny gradient, aby animacja pulsowania była bardziej "premium"
        backgroundImage: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.05), transparent)',
        backgroundSize: '200% 100%'
      }}
    ></div>
  );
};

export default SkeletonLoader;